"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCardLT = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var Image_1 = require("../../../common/Image");
var admin_1 = require("services/page/admin");
var price_1 = require("utils/price");
var website_1 = require("utils/website");
var DiscountInfoCardLT_1 = require("./DiscountInfoCardLT");
var styles = require("./index.scss");
var common_1 = require("services/page/common");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var ProductCardLT = (function (_super) {
    __extends(ProductCardLT, _super);
    function ProductCardLT(props) {
        var _this = _super.call(this, props) || this;
        _this.getDefaultImg = function (shape) {
            if (website_1.isLTMini()) {
                return "";
            }
            if (shape !== admin_1.Shape.RectangleB) {
                return smartimagesrc_1.makeImageUrls(website_1.isLTOuku()
                    ? "https://i.ezbuy.sg/FimGps-Ukjpw5qxKxX_LWD0GnGUS"
                    : "https://i.ezbuy.sg/Fgu47zjp9ABUt-ZQMKa7J-7M-aoW", {
                    online: true
                })[0];
            }
            return smartimagesrc_1.makeImageUrls(website_1.isLTOuku()
                ? "https://i.ezbuy.sg/Flx-yGwyA0_XI940qmT9GngrOa4G"
                : "https://i.ezbuy.sg/FinkFHyvFkDe4HOIJ2zEhe9-YgVM", {
                online: true
            })[0];
        };
        _this.state = {};
        return _this;
    }
    ProductCardLT.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, product = _d.product, type = _d.type, shape = _d.shape, _e = _d.onClick, onClick = _e === void 0 ? function () { } : _e, layout = _d.layout;
        var _f = product.extra || {}, img = _f.img, discountInfo = _f.discountInfo, tag = _f.tag, leftView = _f.leftView, rightView = _f.rightView, titleIcons = _f.titleIcons;
        var productImg = shape === admin_1.Shape.RectangleB ? img.rectangleA : img.square;
        return (React.createElement("a", { target: "_blank", className: classnames_1.default(styles.productCard, (_a = {},
                _a[styles.smallCard] = type === "small",
                _a[styles.singleRoll] = layout.interaction === common_1.ModuleInteraction.RollOver && layout.columnNum === 4,
                _a)), href: product.url, onClick: onClick },
            React.createElement("div", { className: classnames_1.default(styles.image, (_b = {}, _b[styles.square] = shape !== admin_1.Shape.RectangleB, _b)) },
                React.createElement(DiscountInfoCardLT_1.default, { discountInfo: discountInfo, tagInfo: tag, titleIcon: titleIcons && titleIcons[0], type: type }),
                React.createElement(Image_1.default, { defaultSrc: this.getDefaultImg(shape), key: productImg || product.img, className: styles.productImage, src: smartimagesrc_1.makeImageUrls(productImg || product.img, {
                        online: true
                    })[0], params: "imageView2/2/w/300" })),
            React.createElement("div", { className: styles.description },
                React.createElement("p", null, product.name),
                React.createElement("div", { className: styles.currentPrice, style: { color: website_1.isLTMini() ? "#E5760B" : undefined } }, price_1.connectLtPrice(product.price)),
                React.createElement("div", { className: styles.suffix },
                    product.price !== product.originPrice && (React.createElement("span", { className: styles.originPrice }, price_1.connectLtPrice(product.originPrice, true))),
                    leftView && leftView.text && React.createElement("span", { style: styles.leftView }, leftView.text),
                    rightView && rightView.text && (React.createElement("div", { className: styles.rightView },
                        React.createElement("i", { className: classnames_1.default(styles.likeIcon, (_c = {}, _c[styles.mini] = website_1.isLTMini(), _c)) }),
                        React.createElement("span", null, rightView.text)))))));
    };
    ProductCardLT.defaultProps = {
        type: "normal",
        shape: admin_1.Shape.RectangleB
    };
    return ProductCardLT;
}(React.PureComponent));
exports.ProductCardLT = ProductCardLT;
